import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import ArticleServices from "../services/articleServices";

const useArticles = () => {
  const { api, user } = useContext(AuthContext);
  const [articles, setArticles] = useState([]);
  const [oneArticle, setOneArticle] = useState(null);
  const [loadingOne, setLoadingOne] = useState(false);
  const [grouped, setGrouped] = useState([]);
  const [formArticle, setFormArticle] = useState({
    idUtilisateur: "",
    idCategorie: "",
    photos: [],
    oldPhotos: [],
    titre: "",
    description: "",
    prix: "",
    ville: "",
    quartier: "",
    phone: "",
    status: 1,
    archive: 2,
    etat: 2,
    typeAbonnement: 2,
    typeOffre: 1,
    dateExpiration: new Date().toISOString().substring(0, 10),
    idPublicationFacebook: "",
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingArticle, setLoadingArticle] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const service = new ArticleServices(api);

  const findAllArticlesForCategory = async (
    pageNumber = 1,
    filtersParams = {},
  ) => {
    setLoadingArticle(true);

    const limit = filtersParams.limit || 10;
    const params = { page: pageNumber, limit, ...filtersParams };
    const res = await service.getAll(params);

    const data = res.data.data || [];
    const total = res.data.total || 0;

    setTotalPages(Math.ceil(total / limit));
    setHasMore(pageNumber < Math.ceil(total / limit));
    setLoadingArticle(false);
    return { data, total };
  };

  const findAllArticlesGroupeedShuffled = async (
    pageNumber = 1,
    filtersParams = {},
  ) => {
    setLoadingArticle(true);
    const limit = filtersParams.limit || 10;
    const params = { page: pageNumber, limit: limit, ...filtersParams };
    const res = await service.getAllShuffled(params);
    if (res.data.data.length === 0) setHasMore(false);
    setLoadingArticle(false);
    const data = res.data.data || [];
    const total = res.data.total || 0;

    setTotalPages(Math.ceil(total / limit));
    setHasMore(pageNumber < Math.ceil(total / limit));
    setLoadingArticle(false);

    return { data, total };
  };

  const findAllArticlesGrouped = async (pageNumber = 1, filtersParams = {}) => {
    setLoadingArticle(true);
    const params = { page: pageNumber, limit: 10, ...filtersParams };
    const res = await service.getArticlesGroupedByCategory(params);
    if (res.data.data.length === 0) setHasMore(false);
    setLoadingArticle(false);
    return res.data.data;
  };

  const findOneArticle = async (id) => {
    return service.getOne(id);
  };

  const findOneArticleWithCategorie = async (id) => {
    return service.getOne(id);
  };

  const createArticle = async (formData) => {
    return await service.create(`?source=article`, formData);
  };

  const updateArticle = async (id, form) => {
    return await service.update(`?source=article`, id, form);
  };

  const updateArticleStatus = async (id, field, value) => {
    return await service.updateArticleStatus(`${id}`, { [field]: value });
  };

  const getSuggestion = async (query = "") => {
    if (!query || query.trim() === "") {
      setSuggestions([]);
      return;
    }
    return service.getSuggestion({ query: query, limit: 5 });
  };

  const updateArticleCounter = async (id, field, extra = {}) => {
    await service.updateArticleCounter(id, { [field]: true, ...extra,idUtilisateur: user?._id ? user._id : null });
  };

  const findLatestArticleByUser = async (userId) => {
    return service.getLatestArticleByUser(userId);
  };
  const getArticlePublicationStats = async (filtersParams = {}) => {
    const res = await service.getPublicationStats(filtersParams);
    return res.data;
  };

  const getArticleContactEntries = async (id) => {
    const res = await service.getArticleContactEntries(id);
    return res.data;
  };

  const qualifyContactEntry = async (id, canal, entryId, data) => {
    const res = await service.qualifyContactEntry(id, canal, entryId, data);
    return res.data;
  };

  return {
    articles,
    setArticles,
    loadingArticle,
    hasMore,
    page,
    totalPages,
    createArticle,
    updateArticle,
    findOneArticle,
    oneArticle,
    loadingOne,
    formArticle,
    setFormArticle,
    updateArticleStatus,
    findAllArticlesGrouped,
    setGrouped,
    grouped,
    suggestions,
    getSuggestion,
    findAllArticlesForCategory,
    updateArticleCounter,
    findOneArticleWithCategorie,
    findAllArticlesGroupeedShuffled,
    setLoadingArticle,
    findLatestArticleByUser,
    getArticlePublicationStats,
    getArticleContactEntries,
    qualifyContactEntry
  };
};

export default useArticles;
